/**
 * Build filter object from URL search params
 * @param {Object} params - Parsed URL search params
 * @returns {Object} Filter data object for the form
 */
export function buildFilterFromParams(
  params,
  userOptions,
  exceptionStatusOptions,
  exceptionTypeOptions,
  territoryOptions,
  mediaOptions,
) {
  const filterData = {};
  // Text fields
  if (params.releaseId) filterData.releaseId = params.releaseId;
  if (params.releaseTitle) filterData.releaseTitle = params.releaseTitle;
  if (params.catalogName) filterData.catalogName = params.catalogName;
  if (params.licensee) filterData.licensee = params.licensee;
  if (params.dealId) filterData.dealId = params.dealId;
  if (params.catalogId) filterData.catalogId = params.catalogId;

  if (params.mineOnly === "true") {
    filterData.mineOnly = true;
  } else if (params.mineOnly === "false") {
    filterData.mineOnly = false;
  }

  if (params.users && userOptions.length > 0) {
    filterData.users = findOptionsByValues(userOptions, params.users);
  }
  if (params.territories && territoryOptions.length > 0) {
    filterData.territories = findOptionsByValues(
      territoryOptions,
      params.territories,
    );
  }
  if (params.exceptionStatus && exceptionStatusOptions.length > 0) {
    filterData.exceptionStatus = findOptionsByValues(
      exceptionStatusOptions,
      params.exceptionStatus,
    );
  }
  if (params.exceptionType && exceptionTypeOptions.length > 0) {
    filterData.exceptionType = findOptionsByValues(
      exceptionTypeOptions,
      params.exceptionType,
    );
  }
  if (params.medias && mediaOptions.length > 0) {
    filterData.medias = findOptionsByValues(mediaOptions, params.medias);
  }

  if (params.pageSize) {
    filterData.pageSize = Number(params.pageSize);
  }

  return filterData;
}

// Find multiple options by their values (for multi-selects)
export function findOptionsByValues(options, values) {
  if (!Array.isArray(options) || !values) return [];
  const valueArray = Array.isArray(values)
    ? values
    : values.split(",").map((v) => v.trim());
  return valueArray
    .map((val) => options.find((opt) => String(opt.value) === String(val)))
    .filter(Boolean);
}

// Serialize multi-select value to comma-separated string of IDs
function serializeMultiSelect(value) {
  if (!value || (Array.isArray(value) && value.length === 0)) return "";
  if (Array.isArray(value)) {
    return value.map((v) => v?.value ?? v).join(",");
  }
  return value?.value ?? value ?? "";
}

export function cleanTPRExceptionsFilter(
  filter,
  tprExceptionsRange,
  tprExceptionsSort,
) {
  const filtered = {};

  // Text fields
  if (filter.releaseId) filtered.releaseId = filter.releaseId;
  if (filter.releaseTitle) filtered.releaseTitle = filter.releaseTitle;
  if (filter.catalogName) filtered.catalogName = filter.catalogName;
  if (filter.licensee) filtered.licensee = filter.licensee;
  if (filter.dealId) filtered.dealId = filter.dealId;
  if (filter.catalogId) filtered.catalogId = filter.catalogId;

  if (filter.mineOnly === true) {
    filtered.mineOnly = true;
  } else if (filter.mineOnly === false) {
    filtered.mineOnly = false;
  }

  // Multi-select fields
  const usersVal = serializeMultiSelect(filter.users);
  if (usersVal) filtered.users = usersVal;

  const terVal = serializeMultiSelect(filter.territories);
  if (terVal) filtered.territories = terVal;

  const mediaVal = serializeMultiSelect(filter.medias);
  if (mediaVal) filtered.medias = mediaVal;

  const statusVal = serializeMultiSelect(filter.exceptionStatus);
  if (statusVal) filtered.exceptionStatus = statusVal;

  const typeVal = serializeMultiSelect(filter.exceptionType);
  if (typeVal) filtered.exceptionType = typeVal;

  // Pagination
  if (tprExceptionsRange) filtered.tprExceptionsRange = tprExceptionsRange;
  if (tprExceptionsSort) filtered.tprExceptionsSort = tprExceptionsSort;
  if (filter.pageSize) filtered.pageSize = filter.pageSize;

  return filtered;
}
